const getUrlApi = () => {
    return window.location.hostname
}

export default getUrlApi
